import * as React from 'react';
import { CheckboxIndicator } from '@leagueplatform/genesis-core';
import { EntityDetail } from '@web-config-app/core';
import { TableCell } from '../table-pieces.component';

export type CheckboxCellProps = {
  item: EntityDetail;
  disabled?: boolean;
  onChange?: () => void;
  selected?: boolean;
};

export const CheckboxCell = ({
  item,
  disabled,
  onChange,
  selected,
}: CheckboxCellProps) => (
  <TableCell css={{ paddingY: '$threeQuarters' }}>
    <CheckboxIndicator
      id={`entity-${item.id}`}
      name="entity-select"
      disabled={disabled}
      checked={selected}
      onChange={() => {
        onChange?.();
      }}
    />
  </TableCell>
);
